import React, { useState } from "react";
import styles from "./StatutTimeline.module.scss";
import useStore from "../../../../../context/useStore";

const SecteurEditor = ({ vehicleSecteur, onModifierSecteur }) => {
  const [state] = useStore();
  const [selectedSecteur, setSelectedSecteur] = useState("");
  const [showSelector, setShowSelector] = useState(false);

  const secteurs = state?.constant?.items?.CONTRAT?.SECTEURS || {};
  const secteurOptions = [
    ...(secteurs.reunion || []).map((item) => ({
      id: item.id,
      name: `Réunion - ${item.name}`,
    })),
    ...(secteurs.mayotte || []).map((item) => ({
      id: item.id,
      name: `Mayotte - ${item.name}`,
    })),
  ];

  const handleModifierSecteur = () => {
    if (selectedSecteur && onModifierSecteur) {
      onModifierSecteur({ secteur: selectedSecteur });
      setSelectedSecteur("");
      setShowSelector(false);
    }
  };

  const handleCancel = () => {
    setSelectedSecteur("");
    setShowSelector(false);
  };

  return (
    <div className={styles.timeline}>
      <div
        className="d-flex justify-content-end align-items-center mb-2"
        style={{ gap: 8 }}
      >
        {vehicleSecteur && (
          <span className="badge badge-warning">{vehicleSecteur}</span>
        )}
      </div>

      {onModifierSecteur && (
        <div
          className={`${styles.timelineItem} ${styles.addStatutItem} ${styles.last}`}
        >
          <div className={styles.timelineDate}></div>

          <div className={styles.timelineConnector}>
            <div
              className={`${styles.timelineDot} ${styles.addStatutDot} border`}
            >
              <i className="fas fa-pen"></i>
            </div>
          </div>

          <div className={styles.timelineContent}>
            {!showSelector ? (
              <div className={styles.timelineHeader}>
                <button
                  className="btn btn-default mt-1 btn-sm mb-0 text-lowercase"
                  onClick={() => setShowSelector(true)}
                >
                  <i className="fas fa-pen mr-1"></i>
                  Modifier le secteur
                </button>
              </div>
            ) : (
              <div className={styles.addStatutForm}>
                <div className={styles.timelineHeader}>
                  <div className="">
                    <select
                      className="form-control rounded-pill"
                      value={selectedSecteur}
                      onChange={(e) => setSelectedSecteur(e.target.value)}
                    >
                      <option value="">Sélectionner un secteur...</option>
                      {secteurOptions.map((secteur) => (
                        <option key={secteur.id} value={secteur.id}>
                          {secteur.name}
                        </option>
                      ))}
                    </select>
                    <div className="d-flex" style={{ gap: "0.5rem" }}>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={handleModifierSecteur}
                        disabled={!selectedSecteur}
                      >
                        <i className="fas fa-check mr-1"></i>
                        Valider
                      </button>
                      <button
                        className="btn btn-default btn-sm shadow-none border-0"
                        onClick={handleCancel}
                      >
                        <i className="fas fa-times mr-1"></i>
                        Annuler
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SecteurEditor;
